import { h } from '@stencil/core';
export const PauseIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" class="presto-icon-pause">
    <path d="M5 16v-12h3v12h-3zM12 4h3v12h-3v-12z"></path>
  </svg>
);

export const PlayIcon = () => (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" class="presto-icon-play">
    <path d="M5 4l10 6-10 6v-12z"></path>
  </svg>
);
